<div class="row" [ngStyle]="{ 'padding-top': '10px' }">
  <div class="twelve columns">
    <div *ngIf="proxyEnabled">
      <ng-container *ngFor="let proxyUser of proxyUsers">
        <button [ngStyle]="{ 'display' : 'block' }" attr.user={{proxyUser}} soho-menu-button menu="actor-popupmenu" trigger="click" (beforeopen)="onBeforeOpen($event)" (selected)="onSelected($event)">{{proxyUser}}</button><br>
      </ng-container>

      <ul soho-popupmenu id="actor-popupmenu">
        <ng-container *ngFor="let proxyWebApp of proxyWebApps">
          <li soho-popupmenu-item><a soho-popupmenu-label attr.webApp="{{proxyWebApp.proxyWebApp}}">{{proxyWebApp.proxyWebApp}}</a></li>
        </ng-container>
      </ul>
    </div>
    <div *ngIf="proxyMode">
      <ng-container *ngFor="let proxyResetUrl of proxyResetUrls">
        <span [ngStyle]="{ 'display' : 'block' }"><a href="#" class="hyperlink" (click)="onSwitchToProxyClicked(proxyResetUrl.proxyResetWebAppUrl)">{{proxyResetUrl.proxyResetWebApp}}</a></span><br>
      </ng-container>
    </div>
  </div>
</div>
<div class="row" [ngStyle]="{ 'padding-top': '10px' }">
  <div *ngIf="proxyManagementLink" class="twelve columns" style="margin-left: 0px; text-align: left;">
    <label [ngStyle]="{ 'display' : 'inline' }">{{ 'ProxyManagementMessage' | translate }}</label><br>
      <a (click)="onProxyManagementLinkClicked(proxyManagementLink)" class="hyperlink"><span>{{proxyManagementLinkMessage}}</span></a>
  </div>
</div>
